import React from 'react';
import { createStyles, makeStyles, Tooltip as MaterialTooltip } from '@material-ui/core';

type Props = {
  title: string;
  children: React.ReactElement;
  disablePortal?: boolean;
};

const useStyles = makeStyles(() => createStyles({
  tooltip: {
    backgroundColor: '#515B6A',
    fontSize: 12,
  },
}));
const Tooltip = ({ title, children, disablePortal = false }: Props) => {

  const classes = useStyles();

  return (
    <MaterialTooltip
      title={title}
      PopperProps={{ disablePortal }}
      classes={{
        tooltip: classes.tooltip,
      }}
    >
      {children}
    </MaterialTooltip>
  );
};

export default Tooltip;
